
export class SortingArgument {
  field: string;
  descending: boolean;
}